import React from 'react';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getCouthFees } from '../../../services/calc/couthFeesCalc';
import { getWps } from '../../../services/calc/wpsCalc';
import { useTypedSelector } from '../../../store';
import ResultRow from '../SumUpHead/ResultRow';
import { WpsTitle } from './WpsTitle';



const CourtPayment = () => {
  const {
    overallInterestsSum,
    compensationSum,
    finalSum,
  } = useTypedSelector(state =>
    state.sumUp, shallowEqual);

  const { t } = useTranslation();

  return (
    <>
      <WpsTitle title={t('courtPayment.title')} />
      <ResultRow
        sum1={getCouthFees(getWps(finalSum))}
        sum2={getCouthFees(getWps(overallInterestsSum + finalSum))}
        sum3={getCouthFees(getWps(finalSum + compensationSum + overallInterestsSum))}
        legal={t('courtPayment.legal')}
      />
    </>
  );
};



export default CourtPayment;